import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  BrowserRouter
} from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";

import { Main, Jobs, Login } from "./containers";

class App extends Component {
  render() {
    return (
      // <Main />
      // <Router>
      //   <div>
      //     <ul>
      //       <li>
      //         <Link to="/">Home</Link>
      //       </li>
      //       <li>
      //         <Link to="/about">About</Link>
      //       </li>
      //     </ul>

      //     <hr />

      //     <Route exact path="/" component={Main} />
      //     <Route path="/jobs" component={Jobs} />
      //   </div>
      // </Router>
      // <BrowserRouter>
      //   <Switch>
      //     <Route path="/main" component={Main} />
      //     <Route path="/jobs" component={Jobs} />
      //     {/* <Route path="404" component={NotFound} /> */}
      //     {/* <Route path="*" component={NotFound} /> */}
      //   </Switch>
      // </BrowserRouter>

      <Router>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="" exact component={Main} />
        </Switch>
      </Router>
    );
  }
}

export default App;
